/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadDocumentSource = {
    System: 'SYSTEM',
    Uploaded: 'UPLOADED'
} as const;
export type LoadDocumentSource = typeof LoadDocumentSource[keyof typeof LoadDocumentSource];

